import { useEffect, useState } from "react";
import TableCompo from "../Table/TableCompo";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  TableHead,
  TextField,
  CircularProgress,
} from "@mui/material";
import {
  fetchSellOrdersRequest,
  updateSellOrderRequest,
  clearSellMessages,
} from "../../../redux/Order/SellOrdersSlice";
import { CiEdit } from "react-icons/ci";
import CloseIcon from "@mui/icons-material/Close";
import { minWidth } from "@mui/system";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { apiRequest } from "../../../redux/Reports/reportsSlice";
import { canShowPermission } from "../Permissions/permissionObject";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Stack, useMediaQuery, useTheme } from "@mui/material";

const Sell = () => {
  const dispatch = useDispatch();
  const sellOrders = useSelector((state) => state.sellOrders || {});

  const { successMessage, errorMessage } = sellOrders;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [appliedDateRange, setAppliedDateRange] = useState(null);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(clearSellMessages());
    }

    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(clearSellMessages());
    }
  }, [successMessage, errorMessage, dispatch]);

  const { data = [], total = 0 } = sellOrders;

  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");

  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const handleStatusClick = () => {
    setStatusDialogOpen(true);
  };

  const [jewellerDialogOpen, setJewellerDialogOpen] = useState(false);
  const [alreadySuccessDialogOpen, setAlreadySuccessDialogOpen] =
    useState(false);

  const [instaLaxmiDialogOpen, setInstaLaxmiDialogOpen] = useState(false);
  const [alreadySuccessDialogInstaOpen, setAlreadySuccessDialogInstaOpen] =
    useState(false);

  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [paymentId, setPaymentId] = useState("");

  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  // Add local state
  // Loader states (one per confirmation action)

  const [loadingInstaYes, setLoadingInstaYes] = useState(false);
  // const [loadingCancelYes, setLoadingCancelYes] = useState(false);
  // const [loadingPaymentYes, setLoadingPaymentYes] = useState(false);
  const [loadingJewellerYes, setLoadingJewellerYes] = useState(false);
  useEffect(() => {
    const payload = { start: page * limit, limit, search };
    if (appliedDateRange?.start && appliedDateRange?.end) {
      payload.startDate = formatDateTimeRange(appliedDateRange.start, "start");
      payload.endDate = formatDateTimeRange(appliedDateRange.end, "end");
    }
    dispatch(fetchSellOrdersRequest(payload));
  }, [dispatch, page, limit, search, appliedDateRange]);

  const handleGetDetails = () => {
  if (!startDate || !endDate) {
    toast.error("Please select both start and end dates.");
    return;
  }
  if (startDate > endDate) {
    toast.error("Start Date cannot be after End Date");
    return;
  }

  setPage(0);
  setAppliedDateRange({ start: startDate, end: endDate });
};

  const [selectedRow, setSelectedRow] = useState(null);
  console.log("selectedRow", selectedRow);

  const package_name = useSelector(
  (state) => state?.appConfig?.configData?.package_name || "",
  );

  const decimal = useSelector(
      (state) => state?.appConfig?.configData?.decimalPrecision || 4,
    );

  const formatDateTimeRange = (date, type) => {
    if (!date) return null;
    const d = new Date(date);
    if (type === "start") {
      d.setHours(0, 0, 0, 0);
      return d.toISOString();
    }
    d.setDate(d.getDate() + 1);
    d.setHours(0, 0, 0, 0);
    return d.toISOString();
  };

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };

  const [reasonText, setReasonText] = useState("");
  const handleOrderUpdate = (status, customReason = null) => {
    if (!selectedRow?._id) return;

    const reason =
      customReason ??
      prompt("Enter reason for this action:", "Approved by admin");
    if (!reason) return;

    dispatch(
      updateSellOrderRequest({
        transId: selectedRow._id,
        type: "ORDER",
        status,
        reason,
      }),
    );

    setOpenDialog(false);
    setStatusDialogOpen(false);
    setPaymentDialogOpen(false);
    setSelectedRow(null);
  };

  const handleTableChange = (action, tableState) => {
    const dateParams =
    appliedDateRange?.start && appliedDateRange?.end
      ? {
          startDate: formatDateTimeRange(appliedDateRange.start, "start"),
          endDate: formatDateTimeRange(appliedDateRange.end, "end"),
        }
      : {};
    switch (action) {
      case "changePage":
        setPage(tableState.page);
        dispatch(
          fetchSellOrdersRequest({
            start: tableState.page * tableState.rowsPerPage,
            limit: tableState.rowsPerPage,
            search,
            ...dateParams,
          }),
        );
        break;

      case "changeRowsPerPage":
        setLimit(tableState.rowsPerPage);
        setPage(0);
        dispatch(
          fetchSellOrdersRequest({
            start: 0,
            limit: tableState.rowsPerPage,
            search,
            ...dateParams,
          }),
        );
        break;

      case "search":
        const searched = tableState.searchText || "";
        setSearch(searched);
        setPage(0);
        dispatch(
          fetchSellOrdersRequest({
            start: 0,
            limit,
            search: searched,
            ...dateParams,
          }),
        );
        break;

      default:
        break;
    }
  };
  const [permissions, setPermissions] = useState(null);
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (e) {
        console.error("Invalid permissions JSON", e);
        setPermissions({});
      }
    } else {
      setPermissions({});
    }
  }, []);
  useEffect(() => {
    if (successMessage) {
      setOpenDialog(false);
      setStatusDialogOpen(false);
      setPaymentDialogOpen(false);
      setCancelDialogOpen(false);
      setJewellerDialogOpen(false);
      setInstaLaxmiDialogOpen(false);

      setLoadingInstaYes(false);
      setLoadingJewellerYes(false);

      dispatch(clearSellMessages());
    }

    if (errorMessage) {
      toast.error(errorMessage);
      setLoadingInstaYes(false);
      setLoadingJewellerYes(false);

      dispatch(clearSellMessages());
    }
  }, [successMessage, errorMessage]);

  if (permissions === null) {
    return null;
  }
  const canEdit = canShowPermission(permissions, "sell", "edit");
  const columns = [
    ...(canEdit
      ? [
          {
            field: "_id-edit",
            headerName: "Edit",
            render: (value, row) =>
              row.status ? (
                <CiEdit
                  style={{ cursor: "pointer", fontSize: "24px" }}
                  onClick={() => handleEditClick(row)}
                />
              ) : null,
          },
        ]
      : []),
    {
      field: "createdAt",
      headerName: "Date",
      render: (val, row) => {
        if (!row?.createdAt) return "N.A";

        const formattedDate = new Date(row.createdAt).toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        return <span title={formattedDate}>{formattedDate}</span>;
      },
    },
    {
      field: "row.customer",
      headerName: "Name",
      render: (val, row) =>
        row.customer
          ? `${row.customer.firstName || ""} ${row.customer.middleName || ""} ${row.customer.lastName || ""}`
          : "N.A",
    },
    {
      field: "phone",
      headerName: "Phone",
      render: (val, row) =>
        row.customer ? `${row.customer.phone || ""}` : "N.A",
    },
    {
      field: "transactionDetails",
      headerName: "Transaction Details",
      render: (val, row) => {
        const bankName = row?.bankAccount?.bankName;

        if (bankName) {
          return (
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px", // adjust based on your column width
                cursor: "pointer",
              }}
              title={`BANK - ${bankName}`} // shows full info on hover
            >
              <strong>BANK</strong> - {bankName}
            </div>
          );
        } else if (row?.upi?.upiid) {
          return (
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
                cursor: "pointer",
              }}
              title={`UPI - ${row.upi.upiid}`}
            >
              <strong>UPI</strong> - {row.upi.upiid}
            </div>
          );
        } else {
          return <span>N.A</span>;
        }
      },
    },
    {
      field: "verifyStatus",
      headerName: "Bank Verification Status",
      render: (val, row) => {
        const status = row.bankAccount?.verifyStatus || "N.A";
        let color;

        switch (status) {
          case "APPROVED":
            color = "green";
            break;
          case "PENDING":
            color = "blue";
            break;
          default:
            color = "red";
            break;
        }

        return <span style={{ color, fontWeight: "bold" }}>{status}</span>;
      },
    },
    {
      field: "metal",
      headerName: "Metal",
      render: (val, row) => {
        const metal = row?.bullion?.metalName || row?.metalName || "";
        const karat = row?.bullion?.karat || "";
        const purity = row?.bullion?.purity || "";

        if (!metal) return "N.A";

        return `${metal} - ${karat}K - ${purity}`;
      },
    },
    {
      field: "weight",
      headerName: "Weight",
      render: (val, row) => {
        const weight = Number(row?.weight || 0).toFixed(decimal);
        return weight;
      }
    },
    {
      field: "final_amount",
      headerName: "Amount",
      render: (val, row) => {
        const amount = Number(row?.final_amount || 0).toFixed(2);
        return amount;
      }
    },
    {
      field: "status",
      headerName: "Order Status",
      render: (val, row) => {
        let color;

        switch (row.status) {
          case "SUCCESS":
            color = "green";
            break;
          case "PENDING":
            color = "blue";
            break;
          default:
            color = "red";
            break;
        }

        return <span style={{ color, fontWeight: "bold" }}>{row.status}</span>;
      },
    },
  ];

  const handleExportSell = () => {
  if (!startDate || !endDate) {
    toast.error("Please select both start and end dates.");
    return;
  }
  if (startDate > endDate) {
    toast.error("Start Date cannot be after End Date");
    return;
  }

  setExporting(true);
  dispatch(
    apiRequest({
      method: "POST",
      endpoint: "/api/v1/redeem/exportSellOrders",
      body: {
        startDate: formatDateTimeRange(startDate, "start"),
        endDate: formatDateTimeRange(endDate, "end"),
      },
      callback: (response) => {
        setExporting(false);
        if (response?.success) {
          toast.success(response.message || "Export started.");
        } else {
          toast.error(response?.message || "Export failed.");
        }
      },
    }),
  );
};

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box
        sx={{
          width: "100%",
          mt: 0,
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography fontWeight={700} fontSize={24} p={2} fontFamily={"Aeonik"}>
          Sell List
        </Typography>

        <CardContent
          sx={{
            height: "580px",
            width: "100%",
          }}
        > 
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box
              display="flex"
              flexDirection={isMobile ? "column" : "row"}
              gap={1.5}
              px={2}
              py={1}
            >
              <DatePicker
                label="Start Date"
                value={startDate}
                onChange={setStartDate}
                maxDate={endDate || new Date()}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      minWidth: 160,
                      "& .MuiInputBase-root": { height: 36, fontSize: 13 },
                      "& .MuiInputLabel-root": { fontSize: 13 },
                    },
                  },
                }}
              />

              <DatePicker
                label="End Date"
                value={endDate}
                onChange={setEndDate}
                minDate={startDate}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      minWidth: 160,
                      "& .MuiInputBase-root": { height: 36, fontSize: 13 },
                      "& .MuiInputLabel-root": { fontSize: 13 },
                    },
                  },
                }}
              />
              <Button
                variant="outlined"
                fullWidth={isMobile}
                sx={{
                  height: 36,
                  minWidth: 120,
                  fontSize: 13,
                  textTransform: "none",
                  px: 2,
                  whiteSpace: "nowrap",
                }}
                onClick={handleGetDetails}
              >
                Get Details
              </Button>
            </Box>
          </LocalizationProvider>
          <TableCompo
            columns={columns}
            data={JSON.parse(JSON.stringify(data))}
            totalCount={total}
            page={page}
            limit={limit}
            onTableChange={handleTableChange}
            extraButtons={
            <Stack direction="row" spacing={2}>
              <Button
                size="small"
                variant="outlined"
                onClick={handleExportSell}
                disabled={exporting}
              >
                { exporting ? "Exporting..." : "Export Report"}
              </Button>

              <Button
                size="small"
                variant="outlined"
                component="a"
                href={`${
                  process.env.REACT_APP_API_BASE_URL
                  }/static_data/${package_name}/sell.xlsx?nocache=${Date.now()}`}
                  download="sell.xlsx"
                >
                  Download
              </Button>
            </Stack>
          }
          />
        </CardContent>
      </Box>
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        maxWidth="md"
        fullWidth
      >
        {/* Dialog Header */}
        <Box sx={{ backgroundColor: "#0B1A4A", color: "white", p: 3 }}>
          <Box display="flex" justifyContent="space-between">
            <Box>
              <Typography>
                <strong>Full Name:</strong> {selectedRow?.customer?.firstName}{" "}
                {selectedRow?.customer?.lastName}
              </Typography>
              <Typography>
                <strong>Address:</strong>{" "}
                {selectedRow?.customer?.address[0]?.address1}{" "}
                {selectedRow?.customer?.address[0]?.area}{" "}
                {selectedRow?.customer?.address[0]?.city}{" "}
                {selectedRow?.customer?.address[0]?.state}{" "}
                {selectedRow?.customer?.address[0]?.pincode}
              </Typography>
              <Typography>
                <strong>Email:</strong> {selectedRow?.customer?.email || "N.A"}
              </Typography>
              <Typography>
                <strong>Phone Number:</strong> {selectedRow?.customer?.phone}
              </Typography>
              <Typography>
                <strong>Date: </strong>
                {new Date(selectedRow?.createdAt).toLocaleString("en-GB")}
              </Typography>
            </Box>
            <Box textAlign="right">
              <IconButton onClick={handleDialogClose} sx={{ color: "white" }}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>

        {/* Dialog Content */}
        <DialogContent dividers>
          {/* Order Details */}
          <Typography variant="h6" sx={{ color: "red", mt: 2, mb: 1 }}>
            Order Details -
          </Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead sx={{ backgroundColor: "#9CF6FB" }}>
                <TableRow>
                  <TableCell>Metal</TableCell>
                  <TableCell>Weight</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Order Status</TableCell>
                  <TableCell>Verified By</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{selectedRow?.metalName}</TableCell>
                  <TableCell>{selectedRow?.weight}</TableCell>
                  <TableCell>{selectedRow?.final_amount}</TableCell>
                  <TableCell
                    onClick={() => {
                      if (selectedRow?.status === "PENDING") {
                        setStatusDialogOpen(true);
                      } else {
                        setAlreadySuccessDialogOpen(true);
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      style={{
                        fontWeight: "bold",
                        color:
                          selectedRow?.status === "SUCCESS"
                            ? "green"
                            : selectedRow?.status === "PENDING"
                              ? "blue"
                              : "red",
                      }}
                    >
                      {selectedRow?.status}
                    </span>
                  </TableCell>
                  <TableCell>{selectedRow?.verifiedBy || "N.A"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* Bank Details */}
          <Typography variant="h6" sx={{ color: "red", mt: 4, mb: 1 }}>
            Bank Details -
          </Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead sx={{ backgroundColor: "#9CF6FB" }}>
                <TableRow>
                  <TableCell>CUSTOMER NAME</TableCell>
                  <TableCell>Transaction Details</TableCell>
                  <TableCell>ACCOUNT NUMBER</TableCell>
                  <TableCell>IFSC CODE</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    {`${selectedRow?.bankAccount?.firstName || ""} ${
                      selectedRow?.bankAccount?.lastName || ""
                    }`}
                  </TableCell>
                  <TableCell>
                    {selectedRow?.bankAccount
                      ? `BANK:- ${selectedRow?.bankAccount?.bankName}`
                      : selectedRow?.upi
                        ? `UPI:- ${selectedRow?.upi?.upiid}`
                        : "N.A"}
                  </TableCell>
                  <TableCell>
                    {selectedRow?.bankAccount?.accNumber || "N.A"}
                  </TableCell>
                  <TableCell>
                    {selectedRow?.bankAccount?.ifsc || "N.A"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* Verification Details */}
          <Typography variant="h6" sx={{ color: "red", mt: 4, mb: 1 }}>
            Verification Details -
          </Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead sx={{ backgroundColor: "#9CF6FB" }}>
                <TableRow>
                  <TableCell>Jeweller</TableCell>
                  <TableCell>Verify Status</TableCell>
                  <TableCell>InstaLaxmi</TableCell>
                  <TableCell>Verified By</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    onClick={() => {
                      if (selectedRow?.jewellerVerifyStatus === "PENDING") {
                        setJewellerDialogOpen(true);
                      } else {
                        setAlreadySuccessDialogOpen(true);
                      }
                    }}
                    sx={{ cursor: "pointer" }}
                  >
                    <span
                      style={{
                        color:
                          selectedRow?.jewellerVerifyStatus === "SUCCESS"
                            ? "green"
                            : selectedRow?.jewellerVerifyStatus === "PENDING"
                              ? "blue"
                              : "red",
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                    >
                      {selectedRow?.jewellerVerifyStatus || "N.A"}
                    </span>
                  </TableCell>
                  <TableCell>
                    {selectedRow?.verifyByJeweller || "N.A"}
                  </TableCell>
                  <TableCell
                    onClick={() => {
                      if (selectedRow?.instaLaxmiVerifyStatus === "PENDING") {
                        setInstaLaxmiDialogOpen(true);
                      } else {
                        setAlreadySuccessDialogInstaOpen(true);
                      }
                    }}
                    sx={{ cursor: "pointer" }}
                  >
                    <span
                      style={{
                        color:
                          selectedRow?.instaLaxmiVerifyStatus === "SUCCESS"
                            ? "green"
                            : selectedRow?.instaLaxmiVerifyStatus === "PENDING"
                              ? "blue"
                              : "red",
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                    >
                      {selectedRow?.instaLaxmiVerifyStatus || "N.A"}
                    </span>
                  </TableCell>
                  <TableCell>
                    {selectedRow?.verifyByInstaLaxmi || "N.A"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
      <Dialog
        open={statusDialogOpen}
        onClose={() => setStatusDialogOpen(false)}
      >
        <DialogTitle>Select an Option to Continue</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            What would you like to do with this order?
          </Typography>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                setStatusDialogOpen(false);
                setPaymentDialogOpen(true); // open payment dialog
              }}
            >
              Complete Order
            </Button>

            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                setStatusDialogOpen(false);
                setCancelDialogOpen(true);
              }}
            >
              Cancel Order
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={paymentDialogOpen}
        onClose={() => setPaymentDialogOpen(false)}
      >
        <DialogTitle>Enter Payment ID</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Please enter the Payment ID to complete the order.
          </Typography>
          <TextField
            fullWidth
            label="Payment ID"
            value={paymentId}
            onChange={(e) => setPaymentId(e.target.value)}
            margin="normal"
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                if (!paymentId) {
                  alert("Please enter a valid Payment ID.");
                  return;
                }
                handleOrderUpdate("SUCCESS", paymentId); // use payment ID as reason
                setPaymentDialogOpen(false);
                setPaymentId("");
              }}
            >
              Confirm
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        open={cancelDialogOpen}
        onClose={() => setCancelDialogOpen(false)}
      >
        <DialogTitle>Cancel Order</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Please enter reason to cancel this order:
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder="Reason for cancellation"
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
          />
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button onClick={() => setCancelDialogOpen(false)} sx={{ mr: 1 }}>
              Close
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                if (!cancelReason.trim()) return;

                dispatch(
                  updateSellOrderRequest({
                    transId: selectedRow?._id,
                    type: "ORDER",
                    status: "CANCELLED",
                    reason: cancelReason.trim(),
                  }),
                );

                setCancelDialogOpen(false);
                setStatusDialogOpen(false);
                setSelectedRow(null);
                setCancelReason("");
              }}
            >
              Confirm
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={jewellerDialogOpen}
        onClose={() => setJewellerDialogOpen(false)}
      >
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to verify this order as jeweller?
          </Typography>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button onClick={() => setJewellerDialogOpen(false)} sx={{ mr: 1 }}>
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={loadingJewellerYes}
              onClick={() => {
                setLoadingJewellerYes(true);
                dispatch(
                  updateSellOrderRequest({
                    transId: selectedRow?._id,
                    status: "SUCCESS",
                    reason: "Verified by Jeweller",
                    type: "JEWELLER",
                    callback: () => {
                      setLoadingJewellerYes(true);
                      setJewellerDialogOpen(false);
                      setSelectedRow(null);
                      setOpenDialog(false);
                    },
                  }),
                );
              }}
            >
              {loadingJewellerYes ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "OK"
              )}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        open={alreadySuccessDialogOpen}
        onClose={() => setAlreadySuccessDialogOpen(false)}
      >
        <DialogTitle>Info</DialogTitle>
        <DialogContent>
          <Typography>This order has already been verified.</Typography>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button onClick={() => setAlreadySuccessDialogOpen(false)}>
              Close
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        open={instaLaxmiDialogOpen}
        onClose={() => setInstaLaxmiDialogOpen(false)}
      >
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to verify this order as InstaLaxmi?
          </Typography>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              onClick={() => setInstaLaxmiDialogOpen(false)}
              sx={{ mr: 1 }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={loadingInstaYes}
              onClick={() => {
                setLoadingInstaYes(true);
                dispatch(
                  updateSellOrderRequest({
                    transId: selectedRow?._id,
                    status: "SUCCESS",
                    reason: "Verified by InstaLaxmi",
                    type: "INSTALAXMI",
                    callback: () => {
                      setLoadingInstaYes(true);
                      setInstaLaxmiDialogOpen(false);
                      setSelectedRow(null);
                      setOpenDialog(false);
                    },
                  }),
                );
              }}
            >
              {loadingInstaYes ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "OK"
              )}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        open={alreadySuccessDialogInstaOpen}
        onClose={() => setAlreadySuccessDialogInstaOpen(false)}
      >
        <DialogTitle>Info</DialogTitle>
        <DialogContent>
          <Typography>This order has already been verified .</Typography>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button onClick={() => setAlreadySuccessDialogInstaOpen(false)}>
              Close
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Sell;
